import { QueryClient } from "@tanstack/react-query";

// Nothing is cached today (every call site refetches from scratch), so any
// staleTime is a strict improvement. Kept short — this app has no realtime
// invalidation strategy beyond explicit invalidateQueries calls, so a long
// staleTime would just mean stale UI after a write from another tab/device.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
